var parser = null;

var getParser = function getParser() {
  if (parser === null) {
    parser = new window.DOMParser();
  }

  return parser;
};

var wrapMarkup = function wrapMarkup(markup) {
  return "<!DOCTYPE html>\n<html><body>".concat(markup, "</body></html>");
};

var parseDom = function parseDom(markup) {
  return getParser().parseFromString(wrapMarkup(markup), 'text/html').querySelector('body').childNodes;
};

export default parseDom;